import React from 'react';
import { TooltipContainer, TooltipDialog } from './Tooltip.style';
import { ITooltip } from './Tooltip.i';

export const WithTooltip = (props: ITooltip) => {
  return (
    <TooltipContainer {...props} >
      <TooltipDialog position={props.position} offset={props.offset}>{props.text}</TooltipDialog>
      {props.children}
    </TooltipContainer>
  );
};
